export default __webpack_public_path__ + "static/blob4-92934308e0b549a5a42a2378d8f9aa14.svg";